export default "__VITE_ASSET__DTtRMHUQ__"